export default {
	ALLERGENES: 'Allergenes',
	ALLERGEN_CATEGORIES: 'Allergens categories'
};